import { Box } from '@mui/material'
import React from 'react'
import RealGDPGrowthChart from './RealGDPGrowthChart'

export default function RealGDPGrowthRates() {
  return (
    <>
      <Box>
        <RealGDPGrowthChart />
      </Box>
    </>
  )
}